export default {
  SYWInfo: 'payProgramInfoSyw',
};
